'use client';

import { type PropsWithChildren, useEffect } from 'react';
import { useCustomerAuthStore } from '@/stores/customer-auth-store';
import { getAuthenticatedCustomer } from '@/components/Modal/LoginModal/utils';

/**
 * Provides customer authentication state hydration on app mount.
 * Syncs the Zustand auth store with localStorage/cookie data.
 */
export function CustomerAuthProvider({ children }: PropsWithChildren) {
	const syncFromStorage = useCustomerAuthStore((state) => state.syncFromStorage);

	useEffect(() => {
		// Hydrate store from localStorage on mount
		const authData = getAuthenticatedCustomer();
		syncFromStorage(authData);
	}, [syncFromStorage]);

	return <>{children}</>;
}
